import {getThemeConfig} from "@buildwithflux/mui-theme";
import {createTheme} from "@mui/material/styles";

// Same theme config as the main app so both render paths match production.
export const theme = createTheme(getThemeConfig(true));
